import * as React from 'react';
import { Dropdown, Menu, Button } from 'antd';

export interface IZoomRowAction {
  key: string;
  label: string;
  disabled?: boolean;
  danger?: boolean;
  onClick: () => void;
}

interface IZoomRowActionsProps {
  actions: IZoomRowAction[];
}

/** Compact `⋯` dropdown of per-row actions for the Zoom tables. */
export const ZoomRowActions = ({ actions }: IZoomRowActionsProps) => {
  const overlay = (
    <Menu>
      {actions.map((action) => (
        <Menu.Item
          key={action.key}
          disabled={action.disabled}
          danger={action.danger}
          onClick={action.onClick}
        >
          {action.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={overlay} trigger={['click']} placement="bottomRight">
      <Button type="text" size="small">
        ⋯
      </Button>
    </Dropdown>
  );
};
